import { render, staticRenderFns } from "./GerarLicenca.vue?vue&type=template&id=aa3a491a&scoped=true&"
import script from "./GerarLicenca.vue?vue&type=script&lang=js&"
export * from "./GerarLicenca.vue?vue&type=script&lang=js&"
import style0 from "./GerarLicenca.vue?vue&type=style&index=0&id=aa3a491a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3a491a",
  null
  
)

export default component.exports